export const resetIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M9.00039 0.899902C13.4739 0.899902 17.1004 4.5264 17.1004 8.9999C17.1004 13.4734 13.4739 17.0999 9.00039 17.0999C4.52688 17.0999 0.900391 13.4734 0.900391 8.9999C0.900391 6.45536 2.07369 4.18486 3.90879 2.6999"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.900391 2.24988H4.50039V5.84988"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const plusSvg = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_21_1718)">
      <path
        d="M10.0003 18.3334C14.6027 18.3334 18.3337 14.6025 18.3337 10.0001C18.3337 5.39771 14.6027 1.66675 10.0003 1.66675C5.39795 1.66675 1.66699 5.39771 1.66699 10.0001C1.66699 14.6025 5.39795 18.3334 10.0003 18.3334Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.66675V13.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 10H13.3337"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_21_1718">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
export const minusSvg = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_21_1723)">
      <path
        d="M10.0003 18.3334C14.6027 18.3334 18.3337 14.6025 18.3337 10.0001C18.3337 5.39771 14.6027 1.66675 10.0003 1.66675C5.39795 1.66675 1.66699 5.39771 1.66699 10.0001C1.66699 14.6025 5.39795 18.3334 10.0003 18.3334Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 10H13.3337"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_21_1723">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const checkmarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const thumbsDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 4H7a4 4 0 0 0-4 4v12l5-5h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" />
  </svg>
);

export const chevronBottom = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const infoSvg = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16V12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8H12.01"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const sunIcon = (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <path
      d="M18.9668 12.4102C19.154 12.3059 19.3188 12.1658 19.4515 11.9979C19.5843 11.83 19.6825 11.6376 19.7405 11.4318C19.7985 11.226 19.8152 11.0109 19.7895 10.7986C19.7639 10.5864 19.6965 10.3813 19.5911 10.1951L16.2011 4.3462C16.1014 4.14833 15.9622 3.97286 15.7921 3.83056C15.6219 3.68826 15.4243 3.58214 15.2115 3.51873C14.9986 3.45532 14.775 3.43594 14.5544 3.4618C14.3338 3.48765 14.1208 3.5582 13.9285 3.66909C13.7363 3.77998 13.5688 3.92888 13.4364 4.10665C13.304 4.28441 13.2094 4.48728 13.1585 4.70279C13.1077 4.9183 13.1015 5.1419 13.1406 5.35985C13.1796 5.5778 13.2629 5.78551 13.3854 5.9702L16.763 11.8129C16.9784 12.1804 17.3301 12.449 17.7423 12.5607C18.1545 12.6724 18.5942 12.6184 18.9668 12.4102Z"
      fill="currentColor"
    />
    <path
      d="M11.7674 16.7844L5.89877 13.4057C5.71339 13.2802 5.50403 13.1941 5.28376 13.1529C5.0635 13.1117 4.83707 13.1162 4.61863 13.1661C4.40019 13.2161 4.19443 13.3104 4.01423 13.4432C3.83402 13.576 3.68324 13.7444 3.5713 13.9379C3.45937 14.1314 3.38869 14.3458 3.36369 14.5678C3.33868 14.7898 3.35989 15.0145 3.42599 15.2279C3.49208 15.4414 3.60164 15.6389 3.74781 15.8082C3.89399 15.9775 4.07364 16.115 4.27553 16.2119L10.1442 19.5906C10.3295 19.7161 10.5389 19.8022 10.7592 19.8434C10.9794 19.8847 11.2059 19.8802 11.4243 19.8302C11.6428 19.7803 11.8485 19.6859 12.0287 19.5532C12.2089 19.4204 12.3597 19.2519 12.4716 19.0584C12.5836 18.8649 12.6542 18.6505 12.6793 18.4285C12.7043 18.2066 12.683 17.9818 12.617 17.7684C12.5509 17.555 12.4413 17.3574 12.2951 17.1881C12.149 17.0188 11.9693 16.8814 11.7674 16.7844Z"
      fill="currentColor"
    />
    <path
      d="M9.93208 28.0031C9.93208 27.5735 9.76126 27.1614 9.45702 26.857C9.15278 26.5526 8.73992 26.3808 8.30883 26.3792H1.52867C1.11475 26.4047 0.726188 26.5866 0.442157 26.8878C0.158126 27.189 0 27.5867 0 28C0 28.4134 0.158126 28.8111 0.442157 29.1123C0.726188 29.4135 1.11475 29.5954 1.52867 29.6209H8.30883C8.73884 29.6193 9.15076 29.4483 9.45482 29.1453C9.75888 28.8422 9.93043 28.4317 9.93208 28.0031Z"
      fill="currentColor"
    />
    <path
      d="M10.1317 36.4094L4.27553 39.7881C4.07364 39.885 3.89399 40.0225 3.74781 40.1918C3.60164 40.3611 3.49208 40.5586 3.42599 40.7721C3.35989 40.9855 3.33868 41.2102 3.36369 41.4322C3.38869 41.6541 3.45937 41.8686 3.5713 42.0621C3.68324 42.2556 3.83402 42.424 4.01423 42.5568C4.19443 42.6896 4.40019 42.7839 4.61863 42.8339C4.83707 42.8838 5.0635 42.8883 5.28376 42.8471C5.50403 42.8059 5.71339 42.7198 5.89877 42.5943L11.7674 39.2156C11.9693 39.1186 12.149 38.9812 12.2951 38.8119C12.4413 38.6426 12.5509 38.445 12.617 38.2316C12.683 38.0182 12.7043 37.7934 12.6793 37.5715C12.6542 37.3495 12.5836 37.1351 12.4716 36.9416C12.3597 36.7481 12.2089 36.5796 12.0287 36.4468C11.8485 36.3141 11.6428 36.2197 11.4243 36.1698C11.2059 36.1198 10.9794 36.1153 10.7592 36.1566C10.5389 36.1978 10.3295 36.2839 10.1442 36.4094H10.1317Z"
      fill="currentColor"
    />
    <path
      d="M18.9658 43.5897C18.779 43.4847 18.5732 43.4175 18.3602 43.392C18.1473 43.3665 17.9314 43.3831 17.7249 43.4409C17.5184 43.4987 17.3254 43.5966 17.1569 43.7289C16.9885 43.8612 16.8479 44.0253 16.7432 44.2119L13.3531 50.0608C13.2306 50.2455 13.1473 50.4532 13.1083 50.6712C13.0693 50.8891 13.0754 51.1127 13.1263 51.3282C13.1772 51.5437 13.2717 51.7466 13.4041 51.9244C13.5366 52.1021 13.704 52.251 13.8963 52.3619C14.0886 52.4728 14.3016 52.5434 14.5222 52.5692C14.7428 52.5951 14.9664 52.5757 15.1792 52.5123C15.3921 52.4489 15.5896 52.3428 15.7598 52.2005C15.93 52.0582 16.0692 51.8827 16.1688 51.6848L19.5589 45.8359C19.6704 45.6503 19.7436 45.4443 19.7741 45.2301C19.8047 45.0158 19.7919 44.7977 19.7367 44.5884C19.6814 44.3792 19.5848 44.183 19.4524 44.0115C19.32 43.84 19.1546 43.6966 18.9658 43.5897Z"
      fill="currentColor"
    />
    <path
      d="M28.0002 46.0039C27.5691 46.0056 27.1562 46.1774 26.852 46.4818C26.5478 46.7861 26.3769 47.1983 26.377 47.6279V54.379C26.377 54.8089 26.5483 55.2212 26.8533 55.5252C27.1583 55.8291 27.572 55.9999 28.0033 55.9999C28.4347 55.9999 28.8483 55.8291 29.1533 55.5252C29.4583 55.2212 29.6297 54.8089 29.6297 54.379V47.6279C29.6297 47.1972 29.458 46.7841 29.1524 46.4796C28.8468 46.175 28.4324 46.0039 28.0002 46.0039Z"
      fill="currentColor"
    />
    <path
      d="M39.2382 44.1873C39.1385 43.9894 38.9993 43.8139 38.8292 43.6716C38.659 43.5293 38.4614 43.4232 38.2486 43.3598C38.0357 43.2964 37.8121 43.277 37.5915 43.3029C37.3709 43.3287 37.1579 43.3993 36.9656 43.5102C36.7734 43.621 36.6059 43.77 36.4735 43.9477C36.3411 44.1255 36.2465 44.3283 36.1956 44.5438C36.1448 44.7594 36.1387 44.983 36.1777 45.2009C36.2167 45.4189 36.3 45.6266 36.4225 45.8113L39.8126 51.6601C39.9122 51.858 40.0514 52.0335 40.2216 52.1758C40.3918 52.3181 40.5893 52.4242 40.8022 52.4876C41.015 52.551 41.2386 52.5704 41.4592 52.5446C41.6798 52.5187 41.8928 52.4482 42.0851 52.3373C42.2774 52.2264 42.4448 52.0775 42.5773 51.8997C42.7097 51.7219 42.8042 51.5191 42.8551 51.3036C42.906 51.0881 42.9121 50.8645 42.8731 50.6465C42.8341 50.4285 42.7508 50.2208 42.6283 50.0361L39.2382 44.1873Z"
      fill="currentColor"
    />
    <path
      d="M51.7235 39.7881L45.8548 36.4094C45.6694 36.2839 45.4601 36.1978 45.2398 36.1566C45.0196 36.1153 44.7931 36.1198 44.5747 36.1698C44.3562 36.2197 44.1505 36.3141 43.9703 36.4468C43.7901 36.5796 43.6393 36.7481 43.5274 36.9416C43.4154 37.1351 43.3447 37.3495 43.3197 37.5715C43.2947 37.7934 43.3159 38.0182 43.382 38.2316C43.4481 38.445 43.5577 38.6426 43.7039 38.8119C43.85 38.9812 44.0297 39.1186 44.2316 39.2156L50.1002 42.5943C50.2856 42.7198 50.495 42.8059 50.7152 42.8471C50.9355 42.8883 51.1619 42.8838 51.3804 42.8339C51.5988 42.7839 51.8046 42.6896 51.9848 42.5568C52.165 42.424 52.3158 42.2556 52.4277 42.0621C52.5396 41.8686 52.6103 41.6541 52.6353 41.4322C52.6603 41.2102 52.6391 40.9855 52.573 40.7721C52.5069 40.5586 52.3974 40.3611 52.2512 40.1918C52.105 40.0225 51.9254 39.885 51.7235 39.7881Z"
      fill="currentColor"
    />
    <path
      d="M54.4709 26.3792H47.6908C47.2769 26.4047 46.8883 26.5866 46.6043 26.8878C46.3202 27.189 46.1621 27.5867 46.1621 28C46.1621 28.4134 46.3202 28.8111 46.6043 29.1123C46.8883 29.4135 47.2769 29.5954 47.6908 29.6209H54.4709C54.8849 29.5954 55.2734 29.4135 55.5575 29.1123C55.8415 28.8111 55.9996 28.4134 55.9996 28C55.9996 27.5867 55.8415 27.189 55.5575 26.8878C55.2734 26.5866 54.8849 26.4047 54.4709 26.3792Z"
      fill="currentColor"
    />
    <path
      d="M50.1065 13.4057L44.2316 16.7844C44.0297 16.8814 43.85 17.0188 43.7039 17.1881C43.5577 17.3574 43.4481 17.555 43.382 17.7684C43.3159 17.9818 43.2947 18.2066 43.3197 18.4285C43.3447 18.6505 43.4154 18.8649 43.5274 19.0584C43.6393 19.2519 43.7901 19.4204 43.9703 19.5532C44.1505 19.6859 44.3562 19.7803 44.5747 19.8302C44.7931 19.8802 45.0196 19.8847 45.2398 19.8434C45.4601 19.8022 45.6694 19.7161 45.8548 19.5906L51.7235 16.2119C51.9254 16.115 52.105 15.9775 52.2512 15.8082C52.3974 15.6389 52.5069 15.4414 52.573 15.2279C52.6391 15.0145 52.6603 14.7898 52.6353 14.5678C52.6103 14.3458 52.5396 14.1314 52.4277 13.9379C52.3158 13.7444 52.165 13.576 51.9848 13.4432C51.8046 13.3104 51.5988 13.2161 51.3804 13.1661C51.1619 13.1162 50.9355 13.1117 50.7152 13.1529C50.495 13.1941 50.2856 13.2802 50.1002 13.4057H50.1065Z"
      fill="currentColor"
    />
    <path
      d="M42.0476 3.74889C41.8608 3.64391 41.655 3.57672 41.4421 3.55118C41.2291 3.52564 41.0132 3.54225 40.8067 3.60006C40.6002 3.65787 40.4072 3.75574 40.2387 3.88805C40.0703 4.02037 39.9297 4.18453 39.825 4.37111L36.435 10.22C36.3008 10.404 36.2071 10.6141 36.16 10.8367C36.1129 11.0592 36.1133 11.2892 36.1614 11.5115C36.2095 11.7339 36.304 11.9436 36.4389 12.1271C36.5738 12.3105 36.746 12.4636 36.9442 12.5762C37.1425 12.6889 37.3624 12.7586 37.5895 12.7808C37.8166 12.8031 38.0459 12.7774 38.2623 12.7053C38.4788 12.6333 38.6776 12.5166 38.8457 12.3628C39.0139 12.209 39.1476 12.0216 39.2382 11.8129L42.6283 5.964C42.8446 5.5932 42.905 5.15215 42.7962 4.73713C42.6874 4.32212 42.4183 3.96685 42.0476 3.74889Z"
      fill="currentColor"
    />
    <path
      d="M29.6228 8.37821V1.62089C29.6228 1.191 29.4515 0.778722 29.1465 0.474747C28.8415 0.170771 28.4278 0 27.9965 0C27.5651 0 27.1515 0.170771 26.8465 0.474747C26.5415 0.778722 26.3701 1.191 26.3701 1.62089V8.37821C26.3701 8.8081 26.5415 9.22038 26.8465 9.52435C27.1515 9.82833 27.5651 9.9991 27.9965 9.9991C28.4278 9.9991 28.8415 9.82833 29.1465 9.52435C29.4515 9.22038 29.6228 8.8081 29.6228 8.37821Z"
      fill="currentColor"
    />
    <path
      d="M28.0001 41.381C35.4134 41.381 41.4231 35.3916 41.4231 28.0033C41.4231 20.6149 35.4134 14.6255 28.0001 14.6255C20.5868 14.6255 14.5771 20.6149 14.5771 28.0033C14.5771 35.3916 20.5868 41.381 28.0001 41.381Z"
      fill="currentColor"
    />
  </svg>
);
export const securityRank = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_21_1640)">
      <path
        d="M6 20L6 4M12 20L12 10M18 20L18 16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_21_1640">
        <rect width="24" height="24" fill="white" transform="translate(0 24) rotate(-90)" />
      </clipPath>
    </defs>
  </svg>
);
export const startIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M8.99981 2.33325L11.0688 6.81885L15.9742 7.40046L12.3475 10.7543L13.3102 15.5994L8.99981 13.1866L4.68938 15.5994L5.65209 10.7543L2.02539 7.40046L6.9308 6.81885L8.99981 2.33325Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
  </svg>
);
export const dollarIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M9.36203 8.49937V4.92138C10.0435 5.03261 10.6826 5.32447 11.213 5.76658C11.2628 5.81282 11.3211 5.84882 11.3848 5.8725C11.4485 5.89618 11.5162 5.90709 11.5841 5.90461C11.652 5.90212 11.7187 5.88629 11.7805 5.85801C11.8423 5.82974 11.8978 5.78957 11.9441 5.73981C11.9903 5.69005 12.0263 5.63167 12.05 5.56799C12.0737 5.50432 12.0846 5.43661 12.0821 5.36872C12.0796 5.30083 12.0638 5.2341 12.0355 5.17233C12.0073 5.11056 11.9671 5.05497 11.9173 5.00872C11.201 4.37529 10.3087 3.97529 9.35921 3.86207V2.91545C9.35921 2.77722 9.3043 2.64465 9.20655 2.54691C9.10881 2.44916 8.97624 2.39425 8.83801 2.39425C8.69977 2.39425 8.5672 2.44916 8.46946 2.54691C8.37171 2.64465 8.3168 2.77722 8.3168 2.91545V3.85362C6.54189 4.03674 5.291 5.21157 5.291 6.74982C5.291 8.4712 7.26313 9.02058 8.3168 9.2854V13.2465C7.50823 13.0634 6.38694 12.5929 5.94181 12.176C5.84504 12.0792 5.7138 12.0248 5.57696 12.0248C5.44012 12.0248 5.30888 12.0792 5.21212 12.176C5.11536 12.2727 5.061 12.404 5.061 12.5408C5.061 12.6777 5.11536 12.8089 5.21212 12.9057C5.83756 13.5311 7.29975 14.1312 8.31117 14.289V15.1511C8.31117 15.2893 8.36608 15.4219 8.46382 15.5196C8.56157 15.6173 8.69414 15.6723 8.83237 15.6723C8.9706 15.6723 9.10317 15.6173 9.20092 15.5196C9.29866 15.4219 9.35357 15.2893 9.35357 15.1511V14.3059C10.6833 14.1481 12.3794 13.3677 12.3794 11.5928C12.4244 10.2208 11.3201 9.09946 9.36203 8.49937ZM8.31962 8.21764C7.47442 7.9838 6.3475 7.5922 6.3475 6.75545C6.3475 5.65952 7.31384 5.06506 8.31962 4.90448V8.21764ZM9.36203 13.2888V9.59531C10.3002 9.93339 11.3341 10.5616 11.3341 11.6294C11.3708 12.7789 10.0945 13.1423 9.36203 13.2719V13.2888Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9589 4.96404C12.0145 5.01574 12.0594 5.07789 12.091 5.14694C12.1226 5.21599 12.1403 5.2906 12.1431 5.36649C12.1459 5.44238 12.1337 5.51808 12.1072 5.58926C12.0807 5.66044 12.0405 5.72571 11.9888 5.78134C11.9371 5.83697 11.8749 5.88187 11.8059 5.91348C11.7368 5.94509 11.6622 5.96279 11.5863 5.96556C11.5104 5.96834 11.4347 5.95615 11.3636 5.92967C11.2929 5.90339 11.2281 5.86355 11.1727 5.81241C10.6694 5.3932 10.0666 5.11141 9.42302 4.99383V8.4544C11.3639 9.06068 12.4859 10.1909 12.4404 11.5938C12.4401 12.5034 12.0041 13.1589 11.4014 13.6048C10.8164 14.0376 10.0737 14.2739 9.41457 14.3597V15.1511C9.41457 15.3055 9.35323 15.4535 9.24405 15.5627C9.13486 15.6719 8.98678 15.7333 8.83237 15.7333C8.67796 15.7333 8.52988 15.6719 8.42069 15.5627C8.31151 15.4535 8.25017 15.3055 8.25017 15.1511V14.3409C7.74833 14.2565 7.14727 14.0698 6.59258 13.8286C6.01978 13.5795 5.48969 13.2695 5.16899 12.9488C5.06079 12.8406 5 12.6938 5 12.5408C5 12.3878 5.06079 12.241 5.16899 12.1328C5.27719 12.0246 5.42394 11.9638 5.57696 11.9638C5.72964 11.9638 5.87608 12.0244 5.98421 12.1321C6.19914 12.3331 6.58261 12.5514 7.01762 12.7431C7.425 12.9227 7.87179 13.0765 8.2558 13.1696V9.33293C7.73136 9.20022 6.99213 8.99558 6.37674 8.61572C5.74131 8.22351 5.23001 7.63903 5.23001 6.74982C5.23001 5.18839 6.48716 4.00274 8.2558 3.79892V2.91545C8.2558 2.76104 8.31714 2.61296 8.42633 2.50377C8.53551 2.39459 8.6836 2.33325 8.83801 2.33325C8.99241 2.33325 9.1405 2.39459 9.24968 2.50377C9.35887 2.61296 9.42021 2.76104 9.42021 2.91545V3.80823C10.3619 3.9314 11.2457 4.33335 11.9577 4.96302L11.9589 4.96404ZM9.35921 3.86207C10.3087 3.97529 11.201 4.37529 11.9173 5.00872C11.9671 5.05497 12.0073 5.11056 12.0355 5.17233C12.0638 5.2341 12.0796 5.30083 12.0821 5.36872C12.0846 5.43661 12.0737 5.50432 12.05 5.56799C12.0263 5.63167 11.9903 5.69005 11.9441 5.73981C11.8978 5.78957 11.8423 5.82974 11.7805 5.85801C11.7187 5.88629 11.652 5.90212 11.5841 5.90461C11.5162 5.90709 11.4485 5.89618 11.3848 5.8725C11.3211 5.84882 11.2628 5.81282 11.213 5.76658C10.6985 5.33769 10.0816 5.05019 9.42302 4.93184C9.40273 4.92819 9.3824 4.92471 9.36203 4.92138V8.49937C11.3201 9.09946 12.4244 10.2208 12.3794 11.5928C12.3794 13.3677 10.6833 14.1481 9.35357 14.3059V15.1511C9.35357 15.2893 9.29866 15.4219 9.20092 15.5196C9.10317 15.6173 8.9706 15.6723 8.83237 15.6723C8.69414 15.6723 8.56157 15.6173 8.46382 15.5196C8.36608 15.4219 8.31117 15.2893 8.31117 15.1511V14.289C7.29975 14.1312 5.83756 13.5311 5.21212 12.9057C5.11536 12.8089 5.061 12.6777 5.061 12.5408C5.061 12.404 5.11536 12.2727 5.21212 12.176C5.30888 12.0792 5.44012 12.0248 5.57696 12.0248C5.7138 12.0248 5.84504 12.0792 5.94181 12.176C6.37585 12.5825 7.45278 13.04 8.2558 13.2323C8.27632 13.2372 8.29666 13.242 8.3168 13.2465V9.2854C7.26313 9.02058 5.291 8.4712 5.291 6.74982C5.291 5.21157 6.54189 4.03674 8.3168 3.85362V2.91545C8.3168 2.77722 8.37171 2.64465 8.46946 2.54691C8.5672 2.44916 8.69977 2.39425 8.83801 2.39425C8.97624 2.39425 9.10881 2.44916 9.20655 2.54691C9.3043 2.64465 9.35921 2.77722 9.35921 2.91545V3.86207ZM11.3341 11.6294C11.3341 10.5847 10.3444 9.96077 9.42302 9.61765C9.40265 9.61007 9.38232 9.60262 9.36203 9.59531V13.2719C9.38197 13.2684 9.40231 13.2647 9.42302 13.2608C10.163 13.1219 11.3698 12.7476 11.3341 11.6294ZM9.42302 13.1987C9.77835 13.1313 10.2338 13.0101 10.6045 12.7812C10.9982 12.538 11.2906 12.1777 11.2732 11.6314L11.2731 11.6294C11.2731 11.1178 11.0262 10.7092 10.6595 10.3844C10.3133 10.0778 9.86299 9.84854 9.42302 9.68279V13.1987ZM8.31962 8.21764V4.90448C8.29927 4.90773 8.27893 4.91115 8.25862 4.91476C7.27513 5.08933 6.3475 5.68169 6.3475 6.75545C6.3475 7.57222 7.42126 7.96485 8.25862 8.20062C8.27225 8.20446 8.28581 8.20825 8.29931 8.21201C8.3061 8.21389 8.31287 8.21577 8.31962 8.21764ZM8.25862 8.13724V4.97673C7.78839 5.06169 7.33514 5.24337 6.99541 5.52609C6.6402 5.82171 6.4085 6.22785 6.4085 6.75545C6.4085 7.14171 6.66746 7.4327 7.04792 7.66029C7.40469 7.8737 7.8553 8.02308 8.25862 8.13724Z"
      fill="currentColor"
    />
  </svg>
);
export const clockIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle
      cx="9"
      cy="9"
      r="6"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33301 6.33325V9.66659H11.6663"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const locationIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <rect
      x="9"
      y="8.33325"
      width="0.00666667"
      height="0.00666667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M9.00033 15.6667L12.667 12C14.692 9.97496 14.692 6.69171 12.667 4.66667C10.6419 2.64162 7.3587 2.64162 5.33366 4.66667C3.30861 6.69171 3.30861 9.97496 5.33366 12L9.00033 15.6667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
  </svg>
);
export const bedIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M15.4284 8.20719V4.30719C15.4284 3.99946 15.179 3.75005 14.8712 3.75005H3.72838C3.42065 3.75005 3.17123 3.99946 3.17123 4.30719V8.20719C2.24953 8.20719 1.4998 8.95692 1.4998 9.87862V14.3358C1.4998 14.6435 1.74922 14.8929 2.05695 14.8929C2.36468 14.8929 2.61409 14.6435 2.61409 14.3358V13.7786H15.9855V14.3358C15.9855 14.6435 16.2349 14.8929 16.5427 14.8929C16.8504 14.8929 17.0998 14.6435 17.0998 14.3358V9.87862C17.0998 8.95692 16.3501 8.20719 15.4284 8.20719ZM4.28552 4.86433H14.3141V8.20719H13.7569V7.09291C13.7569 6.47838 13.2572 5.97862 12.6427 5.97862H10.9712C10.3567 5.97862 9.85695 6.47838 9.85695 7.09291V8.20719H8.74266V7.09291C8.74266 6.47838 8.2429 5.97862 7.62838 5.97862H5.95695C5.34242 5.97862 4.84266 6.47838 4.84266 7.09291V8.20719H4.28552V4.86433ZM10.9712 8.20719V7.09291H12.6427V8.20719H10.9712ZM5.95695 8.20719V7.09291H7.62838V8.20719H5.95695ZM2.61409 9.87862C2.61409 9.57145 2.86406 9.32148 3.17123 9.32148H15.4284C15.7355 9.32148 15.9855 9.57145 15.9855 9.87862V12.6643H2.61409V9.87862Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5034 4.30719V8.13378C16.4318 8.17318 17.1748 8.94062 17.1748 9.87862V14.3358C17.1748 14.6849 16.8918 14.9679 16.5427 14.9679C16.1935 14.9679 15.9105 14.6849 15.9105 14.3358V13.8536H2.68909V14.3358C2.68909 14.6849 2.4061 14.9679 2.05695 14.9679C1.7078 14.9679 1.4248 14.6849 1.4248 14.3358V9.87862C1.4248 8.94063 2.16777 8.17318 3.09623 8.13378V4.30719C3.09623 3.95804 3.37923 3.67505 3.72838 3.67505H14.8712C15.2204 3.67505 15.5034 3.95804 15.5034 4.30719ZM14.2391 4.93933H4.36052V8.13219H4.76766V7.09291C4.76766 6.43696 5.301 5.90362 5.95695 5.90362H7.62838C8.28433 5.90362 8.81766 6.43696 8.81766 7.09291V8.13219H9.78195V7.09291C9.78195 6.43696 10.3153 5.90362 10.9712 5.90362H12.6427C13.2986 5.90362 13.8319 6.43696 13.8319 7.09291V8.13219H14.2391V4.93933ZM11.0462 7.16791V8.13219H12.5677V7.16791H11.0462ZM6.03195 7.16791V8.13219H7.55338V7.16791H6.03195ZM3.17123 9.39648C2.90548 9.39648 2.68909 9.61287 2.68909 9.87862V12.5893H15.9105V9.87862C15.9105 9.61287 15.6941 9.39648 15.4284 9.39648H3.17123ZM15.4284 8.20719C16.3501 8.20719 17.0998 8.95692 17.0998 9.87862V14.3358C17.0998 14.6435 16.8504 14.8929 16.5427 14.8929C16.2349 14.8929 15.9855 14.6435 15.9855 14.3358V13.7786H2.61409V14.3358C2.61409 14.6435 2.36468 14.8929 2.05695 14.8929C1.74922 14.8929 1.4998 14.6435 1.4998 14.3358V9.87862C1.4998 8.95692 2.24953 8.20719 3.17123 8.20719V4.30719C3.17123 3.99946 3.42065 3.75005 3.72838 3.75005H14.8712C15.179 3.75005 15.4284 3.99946 15.4284 4.30719V8.20719ZM4.28552 4.86433V8.20719H4.84266V7.09291C4.84266 6.47838 5.34242 5.97862 5.95695 5.97862H7.62838C8.2429 5.97862 8.74266 6.47838 8.74266 7.09291V8.20719H9.85695V7.09291C9.85695 6.47838 10.3567 5.97862 10.9712 5.97862H12.6427C13.2572 5.97862 13.7569 6.47838 13.7569 7.09291V8.20719H14.3141V4.86433H4.28552ZM10.9712 8.20719H12.6427V7.09291H10.9712V8.20719ZM5.95695 8.20719H7.62838V7.09291H5.95695V8.20719ZM3.17123 9.32148C2.86406 9.32148 2.61409 9.57145 2.61409 9.87862V12.6643H15.9855V9.87862C15.9855 9.57145 15.7355 9.32148 15.4284 9.32148H3.17123Z"
      fill="currentColor"
    />
  </svg>
);
export const bathIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M2.88856 10.111H3.44412V11.7777C3.44494 12.3175 3.603 12.8453 3.89899 13.2967C4.19498 13.7481 4.61607 14.1035 5.11079 14.3194V15.111C5.11079 15.2584 5.16932 15.3997 5.2735 15.5039C5.37769 15.6081 5.519 15.6666 5.66634 15.6666C5.81368 15.6666 5.95499 15.6081 6.05918 15.5039C6.16337 15.3997 6.2219 15.2584 6.2219 15.111V14.5555H11.7775V15.111C11.7775 15.2584 11.836 15.3997 11.9402 15.5039C12.0444 15.6081 12.1857 15.6666 12.333 15.6666C12.4804 15.6666 12.6217 15.6081 12.7258 15.5039C12.83 15.3997 12.8886 15.2584 12.8886 15.111V14.3194C13.3833 14.1035 13.8044 13.7481 14.1004 13.2967C14.3963 12.8453 14.5544 12.3175 14.5552 11.7777V10.111H15.1108C15.2581 10.111 15.3994 10.0525 15.5036 9.94831C15.6078 9.84413 15.6663 9.70282 15.6663 9.55547C15.6663 9.40813 15.6078 9.26682 15.5036 9.16264C15.3994 9.05845 15.2581 8.99992 15.1108 8.99992H6.77745V3.99992C6.77745 3.85258 6.83598 3.71127 6.94017 3.60708C7.04436 3.50289 7.18567 3.44436 7.33301 3.44436H9.55523C9.70257 3.44436 9.84388 3.50289 9.94807 3.60708C10.0523 3.71127 10.1108 3.85258 10.1108 3.99992V4.61103C9.48336 4.7391 8.91946 5.08002 8.5145 5.57608C8.10955 6.07215 7.88843 6.69289 7.88856 7.33325C7.88856 7.48059 7.94709 7.6219 8.05128 7.72609C8.15547 7.83028 8.29678 7.88881 8.44412 7.88881H12.8886C13.0359 7.88881 13.1772 7.83028 13.2814 7.72609C13.3856 7.6219 13.4441 7.48059 13.4441 7.33325C13.4443 6.69289 13.2231 6.07215 12.8182 5.57608C12.4132 5.08002 11.8493 4.7391 11.2219 4.61103V3.99992C11.2219 3.55789 11.0463 3.13397 10.7337 2.82141C10.4212 2.50885 9.99726 2.33325 9.55523 2.33325H7.33301C6.89098 2.33325 6.46706 2.50885 6.1545 2.82141C5.84194 3.13397 5.66634 3.55789 5.66634 3.99992V8.99992H2.88856C2.74122 8.99992 2.59991 9.05845 2.49573 9.16264C2.39154 9.26682 2.33301 9.40813 2.33301 9.55547C2.33301 9.70282 2.39154 9.84413 2.49573 9.94831C2.59991 10.0525 2.74122 10.111 2.88856 10.111ZM12.2386 6.7777H9.09412C9.20864 6.45215 9.4214 6.17017 9.70302 5.97071C9.98464 5.77124 10.3212 5.66411 10.6663 5.66411C11.0114 5.66411 11.348 5.77124 11.6297 5.97071C11.9113 6.17017 12.124 6.45215 12.2386 6.7777ZM13.4441 10.111V11.7777C13.4441 12.2197 13.2685 12.6436 12.956 12.9562C12.6434 13.2688 12.2195 13.4444 11.7775 13.4444H6.2219C5.77987 13.4444 5.35595 13.2688 5.04339 12.9562C4.73082 12.6436 4.55523 12.2197 4.55523 11.7777V10.111H13.4441Z"
      fill="currentColor"
    />
  </svg>
);
export const tickIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 10L11 14L9 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const smileIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_501_839)">
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="9"
        y="9.5"
        width="0.01"
        height="0.01"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <rect
        x="15"
        y="9.5"
        width="0.01"
        height="0.01"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M15.4649 14C14.7733 15.1956 13.4806 16 12 16C10.5195 16 9.22678 15.1956 8.53516 14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_501_839">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const chevronBottom2 = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_501_1336)">
      <path
        d="M4 7L9 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12L14 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_501_1336">
        <rect width="18" height="18" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
export const personIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M3.33301 14.9998C3.33301 13.1589 4.82539 11.6665 6.66634 11.6665H13.333C15.174 11.6665 16.6663 13.1589 16.6663 14.9998V14.9998C16.6663 15.9203 15.9201 16.6665 14.9997 16.6665H4.99967C4.0792 16.6665 3.33301 15.9203 3.33301 14.9998V14.9998Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinejoin="round"
    />
    <circle cx="10" cy="5.8335" r="2.5" stroke="currentColor" strokeWidth="1.66667" />
  </svg>
);
export const exportIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_501_730)">
      <path
        d="M5.83366 17.5C4.91318 17.5 4.16699 16.7538 4.16699 15.8333V2.5H11.667L15.8337 6.66667V15.8333C15.8337 16.7538 15.0875 17.5 14.167 17.5H5.83366Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.833 2.5V7.5H15.833"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.8335H12.5"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.1665H12.5"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_501_730">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
export const BackIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M9 14l-4 -4l4 -4" />
    <path d="M5 10h11a4 4 0 1 1 0 8h-1" />
  </svg>
);
